import { OpenPanel } from "@openpanel/web";
import Cookies from "js-cookie";

// Stable anonymous id, sent as OpenPanel's __deviceId so it isn't derived from a
// daily-rotating IP hash. The server sets the cookie on page load; this fallback
// only matters when the page wasn't served by it (e.g. local development).
const getDeviceId = () => {
	let id = Cookies.get("ordel_did");
	if (!id) {
		id = window.crypto?.randomUUID
			? window.crypto.randomUUID()
			: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
					const r = Math.floor(Math.random() * 16);
					return (c === "x" ? r : (r & 3) | 8).toString(16);
			  });
		Cookies.set("ordel_did", id, { expires: 400, sameSite: "lax" });
	}
	return id;
};

// Self-hosted OpenPanel.
const op = new OpenPanel({
	clientId: "1140156c-94b7-4acb-b281-9e1000f16ea4",
	apiUrl: "https://stats.ordel.se/api",
	trackScreenViews: true,
	trackOutgoingLinks: true,
	disabled:
		process.env.NODE_ENV !== "production" &&
		process.env.REACT_APP_ANALYTICS !== "1",
});

op.setGlobalProperties({ platform: "web", __deviceId: getDeviceId() });

export default op;
